import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';
import { compose } from 'redux';
import withStyles from 'isomorphic-style-loader/withStyles'
import style from './SRQuestionsPopUp.scss';
import Button from '../Button';
import CloseIcon from '../icons/CloseCircle';
import messages from '../../locale/messages';
import Loader from '../../components/Loader';
import { getSRAdditionalQuestions, saveSRAdditionalQuestionsAnswers } from '../../actions/student';
import {customisedIntlFormatMessage} from '../../utils/helpers';

const localMessages = defineMessages({
  yes: {
    id: 'questionsPopUp.yes',
    defaultMessage: 'Yes',
    description: 'Yes Radio Button',
  },
  no: {
    id: 'questionsPopUp.no',
    defaultMessage: 'No',
    description: 'No Radio Button',
  },
  additionalQuestionsText: {
    id: 'questionsSRPopUp.additionalQuestionsText',
    defaultMessage: 'Summer Rising Supplemental Enrollment Form',
    description: 'Summer Rising Supplemental Enrollment Form',
  },
  submitText: {
    id: 'questionsPopUp.submitText',
    defaultMessage: 'Submit',
    description: 'Submit',
  },
  cancelText: {
    id: 'questionsPopUp.cancelText',
    defaultMessage: 'Cancel',
    description: 'Cancel',
  }
})

class SRQuestionsPopUp extends React.Component {
  constructor(props) {
    super(props);
    this.answers = {};
    this.state = {
      error: '',
      loaded: false,
      additionalQuestions: [],
      additional_error: '',
      api_call_started: false,
      answers: {}
    };
  }

  handleInputChange = (e) => {
    const questionId = e.target.name;
    // clear error if there is one:
    if (this.state.error.length) {
      this.setState({ ...this.state, error: '' });
    }
    if (e.target.type === 'checkbox') {
      if (e.target.checked) {
        this.answers = { ...this.answers, [questionId]: [...this.answers[questionId], e.target.value] };
      } else {
        this.answers = {
          ...this.answers,
          [questionId]: this.answers[questionId].filter((value) => value !== e.target.value),
        };
      }
    } else {
      this.answers = { ...this.answers, [questionId]: [e.target.value] };
      if(e.target.type == 'radio' && $(e.target).attr('short_description').includes('Yes') && $('#sr-additional-questions textarea').val() == 'N/A'){
          $('#sr-additional-questions textarea').val('');
          this.answers = { ...this.answers, [$('#sr-additional-questions textarea').attr('name')]: [] };
      }
    }
    this.setState({
      ...this.state,
      answers: this.answers,
    });
  };

  initAnswers = (answers) => {
    this.setState({
      ...this.state,
      loaded: true,
      answers: answers,
    });
  }

  componentDidMount(){
    const { user, dispatch } = this.props;
    const { applicationId } = user;
    const { loaded } = this.state;
    if (loaded) {
      return;
    }

    const getSRAdditionalQuestionsTask = dispatch(getSRAdditionalQuestions(applicationId)).catch((error) => {
      console.error('Failed to getSRAdditionalQuestions', error);
    });

    Promise.all([getSRAdditionalQuestionsTask])
      .then(() => {
        this.initAnswers(this.answers);
      })
      .catch((error) => {
        console.error('Error', error);
      });
  }

  handleFormSubmit = (e) => {
    e.preventDefault();
    const { dispatch } = this.props;
    const keys = Object.keys(this.answers);
    let if_additional_details_required = false;
    let error_text = '';
    $('input[type="radio"]:checked').each(function(){
      if($(this).attr('short_description').includes('Yes')){
        if_additional_details_required = true;
      }
    });
    if(if_additional_details_required && $('#sr-additional-questions textarea').val().trim() == ''){
      error_text = 'Please provide additional details.';
      $('#sr-additional-questions textarea').val('');
      this.answers = { ...this.answers, [$('#sr-additional-questions textarea').attr('name')]: [] };
    } else {
      if($('#sr-additional-questions textarea').val().trim() == ''){
        $('#sr-additional-questions textarea').val('N/A');
        this.answers = { ...this.answers, [$('#sr-additional-questions textarea').attr('name')]: ['N/A'] };
      }
    }

    // Set to N/A if it was set as N/A in UI
    keys.forEach((kk) => {
      if($("#" + kk).val() == 'N/A'){
        this.answers = { ...this.answers, [$("#" + kk).attr('name')]: ['N/A'] };
      }
      if($("#" + kk).val() != undefined && $("#" + kk).val().trim() == ''){
        if($("#" + kk).attr('short_description').includes('Name/Relationship')){
          this.answers = { ...this.answers, [$("#" + kk).attr('name')]: ['N/A'] };
          $("#" + kk).val('N/A')
        } else {
          this.answers = { ...this.answers, [$("#" + kk).attr('name')]: [''] };
          $("#" + kk).val('')
        }
      }
    });

    if(error_text){
      this.setState({ ...this.state, answers: this.answers, error: error_text });
      return;
    }

    const emptyAnswers = keys.filter(key => this.answers[key].length === 0 || (this.answers[key].length > 0 && $.trim(this.answers[key][0]) == ''));

    if (emptyAnswers.length) {
      this.setState({ ...this.state, answers: this.answers, error: 'Please, answer all questions.' });
      return;
    } else {
      // Trim all answers
      keys.forEach((kk) => {
        this.answers[kk] = [this.answers[kk][0].trim()];
      });
      let api_payload = {};
      api_payload = {"answers": this.answers, "siblings": this.state.siblings, "waitlist_id": this.props.waitListId}
      const {isEdit } = this.props;
      this.setState({ ...this.state, api_call_started: true });
      dispatch(saveSRAdditionalQuestionsAnswers(this.props.waitListId, api_payload, this.props.programId, isEdit)).then((resp) => {
        if(resp['status'] == 'OK'){
          this.props.handleCancelClick();
        }else{
          this.setState({ ...this.state, error: resp['message'], api_call_started: false });
        }
      })
    }
  };

  handleCancelClick = (e) => {
    this.props.handleCancelClick(e);
  }

  render() {
    const { error, loaded, api_call_started } = this.state;
    const { srAdditionalQuestions, intl } = this.props;
    return (
      <div className={style.modalContainer}>
        <div className={style.modalContent}>
          <h2 className={style.modalHeaderText}><FormattedMessage {...localMessages.additionalQuestionsText} /></h2>
          <div className={style.timesContainer}>
            <button type="button" onClick={this.handleCancelClick} aria-label="close">
              <CloseIcon fill="#CCC" />
            </button>
          </div>
          <form id="sr-additional-questions" className={`${api_call_started ? 'hidden' : ''}`}>
            {!loaded && <Loader text={customisedIntlFormatMessage(intl, messages.generalStringLoading)} />}
            {loaded && srAdditionalQuestions.map(
              ({ question_type, short_description, additional_information, id: questionId, question, options, answers: previousAnswers }) => {
                const type = question_type.toLowerCase();
                let input_type = type;
                if(type == 'checkboxes'){
                  input_type = 'checkbox';
                }
                if(!this.answers.hasOwnProperty(questionId)){
                  this.answers = { ...this.answers, [questionId]: [] };
                }
                if (input_type !== 'radio' && input_type !== 'checkbox' && previousAnswers && this.answers[questionId].length < 1) {
                  this.answers = { ...this.answers, [questionId]: [previousAnswers[0].text_answer] };
                } else if (input_type !== 'radio' && input_type !== 'checkbox' && !previousAnswers && short_description.includes('Name/Relationship')){
                  if($('#' + questionId).val() == ''){
                    this.answers = { ...this.answers, [questionId]: ['N/A'] };
                  }
                }
                return (
                  <Fragment key={questionId}>
                    {additional_information && <h3 className={style.additionalQuestionsHeading} dangerouslySetInnerHTML={{ __html: `${additional_information}` }} />}
                    {input_type == 'text' || input_type == 'textarea' ? (
                      <label htmlFor={questionId} dangerouslySetInnerHTML={{ __html: `${question}` }} />
                    ): (
                      <></>
                    )}
                    {options.length ? (
                      <fieldset>
                        <legend dangerouslySetInnerHTML={{ __html: `${question}` }} />
                      {options.map(({ option, id: optionId, short_description: short_description }) => {
                        const checked = previousAnswers ? previousAnswers.findIndex(({ id }) => id === optionId) : -1;
                        if (checked !== -1) {
                          if (this.answers.hasOwnProperty(questionId) && !this.answers[questionId].includes(`${optionId}`)) {
                            this.answers = {
                              ...this.answers,
                              [questionId]: [...this.answers[questionId], `${optionId}`],
                            };
                          }
                        }
                        return (
                          <div key={optionId}>
                            <input
                              type={input_type}
                              id={optionId}
                              value={optionId}
                              name={questionId}
                              onChange={this.handleInputChange}
                              defaultChecked={checked !== -1}
                              short_description={short_description}
                            />
                            <label htmlFor={optionId}>{option}</label>
                          </div>
                        );
                      })}
                      </fieldset>
                    ) : 

                    input_type == 'textarea' ? (
                      <textarea
                        id={questionId}
                        name={questionId}
                        onChange={this.handleInputChange}
                        rows={3}
                        defaultValue={previousAnswers ? previousAnswers[0].text_answer : short_description.includes('Name/Relationship') ? 'N/A' : ''}
                        short_description={short_description}
                      >
                      </textarea>
                      ):
                      (
                        <><input
                          type={input_type}
                          id={questionId}
                          name={questionId}
                          onChange={this.handleInputChange}
                          className='srinput'
                          onKeyPress={this.handleInputChange}
                          defaultValue={previousAnswers ? previousAnswers[0].text_answer : short_description.includes('Name/Relationship') ? 'N/A' : ''}
                          maxLength={255}
                          short_description={short_description}
                        />
                        <p className={style.charCountHelper}>{this.state.answers[questionId] && this.state.answers[questionId].length > 0 ? this.state.answers[questionId][0].length : document.getElementById(questionId) ? document.getElementById(questionId).value.length : 255}/255</p>
                        </>
                      )
                    }
                  </Fragment>
                );
              },
            )}
            {error.length ? (<p className={style.alert}>{error}</p>) : null}
            {
              !api_call_started && loaded && srAdditionalQuestions && srAdditionalQuestions.length > 0 && 
              <>
              <Button buttonType="button" onClick={this.handleFormSubmit} customClass={style.confirmationButton}><FormattedMessage {...localMessages.submitText} /></Button>
              <Button buttonType="button" customClass={style.confirmationButton} onClick={this.handleCancelClick}>
              <FormattedMessage {...localMessages.cancelText} />
              </Button>
              </>
            }
          </form>
          {api_call_started && <Loader text={customisedIntlFormatMessage(intl, messages.generalStringLoading)} />}
        </div>
      </div>
    );
  }
}

SRQuestionsPopUp.propTypes = {
  acceptButtonText: PropTypes.string,
  schoolName: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  handleAcceptClick: PropTypes.func,
  handleCancelClick: PropTypes.func,
};

export default compose(
  injectIntl,
  withStyles(style),
)(SRQuestionsPopUp);